import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { KomodoCoreWrappersModule } from '@komodo-design-system/komodo-core-angular-twelve-wrappers/dist/komodo-core-wrappers';
import { KwaAngular18Module } from '@komodo-design-system/komodo-kwa-angular-18';

import { KpiTrendIndicatorComponent } from './kpi-trend-indicator.component';

@NgModule({
  declarations: [KpiTrendIndicatorComponent],
  exports: [KpiTrendIndicatorComponent],
  imports: [CommonModule, KwaAngular18Module, KomodoCoreWrappersModule, MatIconModule],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class KpiTrendIndicatorModule {}
